module.exports = __webpack_public_path__ + "media/bootstrap-icons/list-nested-dcfcb29c.svg";